import { makeAutoObservable } from "mobx";

import QuoteStore from './quote-store';
import appConstants from './constants';


class BusinessStore {
  constructor() {
    makeAutoObservable(this);
    const { QUOTES } = appConstants.BUSINESS;

    this.quote = new QuoteStore(this, { quickQuote: QUOTES.QUICK });
  }

  async getQuickQuote(data) {
    return await this.quote.getQuickQuote(data);
  }
}

export default BusinessStore